import React from 'react'
import Scrollspy from 'react-scrollspy'
import Scroll from './Scroll'

const Nav = (props) => (
    <nav id="nav" className={props.sticky ? 'alt' : ''}>
        <Scrollspy items={ ['intro', 'first', 'second', 'cta'] } currentClassName="is-active" offset={-300}>
            <li>
                <Scroll type="id" element="intro">
                    <a href="#">About</a>
                </Scroll>
            </li>
            <li>
                <Scroll type="id" element="our-work">
                    <a href="#">Our work</a>
                </Scroll>
            </li>           
            <li>
                <Scroll type="id" element="inquiry-form-wrapper">
                    <a href="#">Get in touch</a>
                </Scroll>
            </li>
        </Scrollspy>
    </nav>
)

export default Nav
